function AdminUsuario() {
    return (
        <div>Admin Usuario</div>
    )
}

export default AdminUsuario